import React, { useEffect, useRef } from "react";
import teaSpillPremium from "@/assets/recovery/tea-spill-premium.jpg";
import {
  RECOVERY_BODY_PRIMARY,
  RECOVERY_BODY_SECONDARY,
  RECOVERY_PRIMARY_LABEL,
  RECOVERY_SECONDARY_LABEL,
  RECOVERY_TITLE,
} from "@/components/recovery/recovery-content";
import "@/styles/recovery.css";

export type AppRecoveryScreenProps = {
  /** Root test id — defaults to app-error-fallback for the error boundary. */
  testId?: string;
  primaryTestId?: string;
  homeTestId?: string;
};

/**
 * Premium branded recovery experience for unexpected application failures.
 * Presentation only — no business / routing / API side effects beyond reload / home.
 */
export function AppRecoveryScreen({
  testId = "app-error-fallback",
  primaryTestId = "app-recovery-try-again",
  homeTestId = "app-recovery-home",
}: AppRecoveryScreenProps): React.ReactElement {
  const primaryRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    primaryRef.current?.focus();
  }, []);

  const handleTryAgain = (): void => {
    window.location.reload();
  };

  const handleHome = (): void => {
    window.location.href = "/";
  };

  return (
    <div className="rx-recovery" role="alert" data-testid={testId}>
      <div className="rx-recovery__card">
        <div className="rx-recovery__media">
          <img
            className="rx-recovery__image"
            src={teaSpillPremium}
            alt=""
            aria-hidden="true"
            draggable={false}
          />
        </div>
        <div className="rx-recovery__content">
          <h1 className="rx-recovery__title">{RECOVERY_TITLE}</h1>
          <p className="rx-recovery__body">{RECOVERY_BODY_PRIMARY}</p>
          <p className="rx-recovery__body">{RECOVERY_BODY_SECONDARY}</p>
          <div className="rx-recovery__actions">
            <button
              ref={primaryRef}
              type="button"
              className="rx-recovery__primary"
              data-testid={primaryTestId}
              onClick={handleTryAgain}
            >
              {RECOVERY_PRIMARY_LABEL}
            </button>
            <button
              type="button"
              className="rx-recovery__secondary"
              data-testid={homeTestId}
              onClick={handleHome}
            >
              {RECOVERY_SECONDARY_LABEL}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AppRecoveryScreen;
